import { data } from 'jquery';
import { updateArticleCurationState } from 'modules/EmailBrowser/utils';
import { WHN_ARTICLES, ALL_ARTICLES_IN_EDITION, CLEAR_ALL_CURATION_CONTENT } from '../../../constants/actionTypes';
import * as interfaces from '../interfaces';
import Article from './../../Design/Shared/Article';

const whnState = {
  data: Array<interfaces.IArticlesItem>(),
  loading: false,
  articleofEditionLoading: false,
  articleofEdition: Array<interfaces.IArticlesItem>(),
  curatedArticlesCount: 0,
  editionName: '',
  digestName: '',
  campaignName: '',
  templateId: 0,
  editionStatus: '',
  userId: 0,
  adminId: 0,
  assetId: 0,
  editionId: 0,
  subject: '',
  page: 0,
  emailType: 0,
  addArticle: {
    loading: false,
    success: false,
    failed: false,
    message: '',
    alreadyAdded: false,
    byUrl: false,
  },
};

export const whnArticlesReducer = (state = whnState, action: interfaces.IArticlesAction) => {
  let newState = { ...state };

  switch (action.type) {
    case ALL_ARTICLES_IN_EDITION.UPDATE_ARTICLES_ORDER:
      newState.articleofEdition = action.payload;
      return newState;
    case ALL_ARTICLES_IN_EDITION.SUBJECT_UPDATE:
      newState.subject = action.payload.subject;
      return newState;
    case WHN_ARTICLES.LOAD_SUCCESS:
      newState.loading = false;
      newState.page = newState.page + 1;
      newState.data = [...state.data, ...action.payload];
      return newState;
    case WHN_ARTICLES.LOAD:
      newState.loading = true;
      return newState;
    case WHN_ARTICLES.LOAD_FAIL:
      newState.loading = false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.LOAD_SUCCESS:
      newState.articleofEditionLoading = false;
      newState.articleofEdition = [...action.payload.list];
      newState.editionName = action.payload.editionName;
      newState.digestName = action.payload.digestName;
      newState.campaignName = action.payload.campaignName;
      newState.templateId = action.payload.templateId;
      newState.editionStatus = action.payload.editionStatus;
      newState.userId = action.payload.userId;
      newState.adminId = action.payload.adminId;
      newState.assetId = action.payload.assetId;
      newState.editionId = action.payload.editionId;
      newState.subject = action.payload.subject;
      newState.emailType = action.payload.emailType;
      return newState;
    case ALL_ARTICLES_IN_EDITION.LOAD:
      newState.articleofEditionLoading = true;
      return newState;

    case ALL_ARTICLES_IN_EDITION.LOAD_FAIL:
      newState.articleofEditionLoading = false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.TEMPLATE_ID_UPDATE:
      newState.templateId = action.payload;
      return newState;
    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_LOAD:
      newState.addArticle.loading = true;
      newState.addArticle.success = false;
      newState.addArticle.alreadyAdded = false;
      newState.addArticle.failed = false;
      newState.addArticle.message = '';
      newState.addArticle.byUrl = action.addByUrl ? action.addByUrl : false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_SUCCESS:
      newState.articleofEdition.push(action.payload.list);
      newState.addArticle.success = true;
      newState.addArticle.loading = false;
      newState.addArticle.alreadyAdded = false;
      newState.addArticle.failed = false;
      newState.addArticle.byUrl = action.addByUrl ? action.addByUrl : false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_ALREADY_ADDED:
      newState.addArticle.success = true;
      newState.addArticle.loading = false;
      newState.addArticle.alreadyAdded = true;
      newState.addArticle.failed = false;
      newState.addArticle.message = action.payload.message;
      newState.addArticle.byUrl = action.addByUrl ? action.addByUrl : false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.ADD_ARTICLE_BY_FILE_FAILED:
      newState.addArticle.success = false;
      newState.addArticle.loading = false;
      newState.addArticle.failed = true;
      newState.addArticle.message = action.payload.message;
      newState.addArticle.byUrl = action.addByUrl ? action.addByUrl : false;
      return newState;
    case ALL_ARTICLES_IN_EDITION.RESET_ARTICLE_STATE:
      newState.addArticle.success = false;
      newState.addArticle.loading = false;
      newState.addArticle.failed = false;
      newState.addArticle.message = '';
      newState.addArticle.alreadyAdded = false;
      newState.addArticle.byUrl = action.addByUrl ? action.addByUrl : false;
      return newState;
    case WHN_ARTICLES.ADD_CURATE:
      newState.data = updateArticleCurationState(newState.data, action.curate_article_id, true);
      return newState;
    case WHN_ARTICLES.REMOVE_CURATE:
      newState.data = updateArticleCurationState(newState.data, action.curate_article_id, false);
      return newState;
    case WHN_ARTICLES.ADD_FAVOURITE:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = true;
        }
        return item;
      });
      return newState;
    case WHN_ARTICLES.REMOVE_FAVOURITE:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_favourite = false;
        }
        return item;
      });
      return newState;

    case WHN_ARTICLES.ADD_CHECK:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_checked = true;
        }
        return item;
      });
      return newState;
    case WHN_ARTICLES.REMOVE_CHECK:
      newState.data = state.data.filter((item) => {
        if (item.id === action.payload) {
          item.is_checked = false;
        }
        return item;
      });
      return newState;
    case WHN_ARTICLES.REMOVE_ALL_CHECK:
      newState.data = state.data.filter((item) => {
        item.is_checked = false;
        return item;
      });
      return newState;
    case CLEAR_ALL_CURATION_CONTENT.LOAD:
      newState.articleofEditionLoading = true;
      return newState;
    case CLEAR_ALL_CURATION_CONTENT.LOAD_SUCCESS:
      newState.articleofEditionLoading = false;
      newState.articleofEdition = [];
      return newState;
    case CLEAR_ALL_CURATION_CONTENT.LOAD_FAIL:
      newState.articleofEditionLoading = false;
      return newState;
    case CLEAR_ALL_CURATION_CONTENT.REMOVE_SINGLE_ARTICLE_LOAD_SUCCESS:
      newState.articleofEditionLoading = false;
      let index = newState.articleofEdition.findIndex((x) => x.id === action.payload.articleId);
      newState.articleofEdition = [
        ...newState.articleofEdition.slice(0, index),
        ...newState.articleofEdition.slice(index + 1),
      ];
      return newState;

    default:
      return state;
  }
};
